<template>
  <div>
    <v-combobox
      v-model="selected"
      :filter="filter"
      :hide-no-data="!search"
      :items.sync="items"
      :search-input.sync="search"
      dense
      small-chips
      hide-selected
      :label="emailSelectorLabel"
      item-value="email"
      :allow-overflow="false"
      :readonly="readonly"
      outlined
      multiple
      flat
      @input="updateSelection"
      @keyup.188="updateSelection"
      @keyup.186="updateSelection"
      @keyup.13="updateSelection"
      @keyup.32="updateSelection"
    >
      <template v-slot:no-data>
        <div @keyup.32="updateSelection">
          <v-list-item>Add email &nbsp; {{ search }}</v-list-item>
          <v-list-item v-if="pricingOption">
            <v-switch
              v-if="pricingOption"
              v-model="includePricing"
              label="Include Pricing"
            />
          </v-list-item>
        </div>
      </template>
      <template v-slot:selection="{ attrs, item, parent, selected }">
        <v-chip
          v-if="item === Object(item)"
          v-bind="attrs"
          :input-value="selected"
          label
          small
        >
          <v-avatar v-if="pricingOption" left>
            <v-icon color="red accent-4" v-if="item.includePricing"
              >attach_money</v-icon
            >
            <v-icon v-else>money_off</v-icon>
          </v-avatar>
          <span class="pr-2">{{ item.email }}</span>
          <v-icon small @click="parent.selectItem(item)">close</v-icon>
        </v-chip>
      </template>
      <template v-slot:item="{ index, item }">
        <v-chip label small>{{ item.email }} </v-chip>
        <v-spacer></v-spacer>
        <div @click.stop v-if="pricingOption">
          <v-switch label="Include Pricing" v-model="item.includePricing" />
        </div>
      </template>
    </v-combobox>
  </div>
</template>

<script>
import isValidEmail from "@/modules/isValidEmail";
import { uniq, uniqBy } from "lodash";

export default {
  props: {
    emailSelectorLabel: {
      type: String,
    },
    selectedEmails: {
      type: Array,
      required: true,
    },
    emailIndex: {
      type: Number,
      required: true,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    pricingOption: {
      type: Boolean,
      default: true,
    },
    options: {
      type: Array,
      default: () => {
        return [];
      },
    },
    event: {
      type: String,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const items = [
      {
        header: "Select an email or create one",
      },
      ...this.options,
      ...this.selectedEmails,
    ];

    return {
      index: -1,
      items,
      selected: this.selectedEmails,
      includePricing: false,
      search: "",
    };
  },
  watch: {
    selectedEmails: {
      handler(emails) {
        this.selected = emails;
      },
      deep: true,
    },
  },
  methods: {
    filter(item, queryText) {
      if (item.header) return false;
      const hasValue = (val) => (val != null ? val : "");
      const text = hasValue(item.email);
      const query = hasValue(queryText);
      return (
        text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) >
        -1
      );
    },
    updateSelection() {
      const emails = uniq([
        ...this.selected,
        ...[this.search || "".replace(";", "")], // TOOD - fix this later
      ]);
      const { event, multiple } = this;
      const formattedEmails = emails
        .filter((email) => email)
        .map((email) => {
          if (typeof email === "string") {
            if (!isValidEmail(email)) return;
            const formattedEmail = {
              email,
              includePricing: this.includePricing,
            };
            if (event) {
              formattedEmail.event = event;
            }
            return formattedEmail;
          } else {
            if (event) {
              email.event = event;
            }
            if (!isValidEmail(email.email)) return;
            return email;
          }
        });

      this.selected = multiple ? formattedEmails : [formattedEmails.pop()];
      this.selected = this.selected.map((elem) => {
        return {
          ...elem,
          email: elem.email.replace(",", "").replace(";", ""),
        };
      });
      this.search = "";
      this.$emit("update:selectedEmails", this.selected);
      this.includePricing = false;
    },
  },
};
</script>
